import { ITerm } from "@evennt-tech/api-v2-core";

const scrollToElement = (termId: string, categoryId: string) => {
  const id = `${categoryId}_${termId}`;
  const element = document.getElementById(id);

  if (element) {
    element.scrollIntoView({ block: "start", behavior: "smooth" });
  }
};

type UseScrollToTermParams = {
  terms: ITerm[];
  termId?: string;
  categoryId?: string;
};

export const scrollToTermById = ({
  termId,
  categoryId,
}: UseScrollToTermParams) => {
  if (termId && categoryId) {
    const scroll = async () => scrollToElement(termId, categoryId);
    scroll();
  }
};
